import { useEffect, useState } from 'react';

const getReducedEffectsState = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  return window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false;
};

function useReducedEffects() {
  const [shouldReduceEffects, setShouldReduceEffects] = useState(getReducedEffectsState);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) {
      return undefined;
    }

    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    const handleChange = () => setShouldReduceEffects(mediaQuery.matches);

    handleChange();

    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', handleChange);
      return () => mediaQuery.removeEventListener('change', handleChange);
    }

    mediaQuery.addListener(handleChange);
    return () => mediaQuery.removeListener(handleChange);
  }, []);

  return shouldReduceEffects;
}

export default useReducedEffects;
